import React from 'react';
import { CustomPageWidget, Coachie } from '../../pages/custom-page/sections';

export const MABImportPortfolioTemplate = React.memo(({ page, widgets }) => {
  const { widget, coachie } = page;
  return (
    <CustomPageWidget widgets={widgets} {...widget}>
      {['manual', 'digital'].includes(coachie.display) && <Coachie {...coachie} />}
    </CustomPageWidget>
  );
});
